import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";

import { library } from "@fortawesome/fontawesome-svg-core";
import { fas } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import Multiselect from "vue-multiselect";
import BootstrapVue from "bootstrap-vue";
import Datetime from "vue-datetime";
import "vue-datetime/dist/vue-datetime.css";
import Notifications from "vue-notification";
import SweetModal from "sweet-modal-vue/src/plugin.js";

import "bootstrap/dist/css/bootstrap.css";
import "bootstrap-vue/dist/bootstrap-vue.css";

import "./custom.css";
import "./vue-multiselect.css";
// import "./vue-multiselect-new.css";

import AirbnbStyleDatepicker from "vue-airbnb-style-datepicker";
import "vue-airbnb-style-datepicker/dist/vue-airbnb-style-datepicker.min.css";

import DatePicker from "vue2-datepicker";
import "vue2-datepicker/index.css";

import VueFlatPickr from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";
import Swal from "sweetalert2";
import Autocomplete from "v-autocomplete";
// You need a specific loader for CSS files like https://github.com/webpack/css-loader
import "v-autocomplete/dist/v-autocomplete.css";
import vSelect from "vue-select";
import "vue-select/dist/vue-select.css";
import * as numeral from "numeral";

// utility
import _ from "lodash";
import sugar from "sugar";
import v from "voca";
import rfdc from "rfdc";
import VModal from "vue-js-modal";

Vue.config.productionTip = false;

// add global
Vue.prototype.$_ = _;
Vue.prototype.$sugar = sugar;
Vue.prototype.$swal = Swal;
Vue.prototype.$v = v;
Vue.prototype.$rfdc = rfdc();
Vue.prototype.$numeral = numeral;
Vue.use(VModal);

library.add(fas);

const datepickerOptions = {
  sundayFirst: false,
  dateLabelFormat: "dddd, MMMM D, YYYY",
  days: [
    "Monday",
    "Tuesday",
    "Wednesday",
    "Thursday",
    "Friday",
    "Saturday",
    "Sunday",
  ],
  daysShort: ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"],
  monthNames: [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
  ],
  colors: {
    selected: "#fb822b",
    inRange: "#f5b88d",
    selectedText: "#fff",
    text: "#565a5c",
    inRangeBorder: "#fc9850",
    disabled: "#fff",
  },
  texts: {
    apply: "Apply",
    cancel: "Cancel",
  },
  // ariaLabels: {
  //     chooseDate: date => date,
  //     chooseStartDate: date => `Choose ${date} as your start date.`,
  //     chooseEndDate: date => `Choose ${date} as your end date.`,
  //     selectedDate: date => `Selected. ${date}`,
  //     unavailableDate: date => `Not available. ${date}`,
  //     previousMonth: "Move backward to switch to the previous month.",
  //     nextMonth: "Move forward to switch to the next month.",
  //     closeDatepicker: "Close calendar",
  //     openKeyboardShortcutsMenu: "Open keyboard shortcuts menu.",
  //     closeKeyboardShortcutsMenu: "Close keyboard shortcuts menu"
  // },
  // keyboardShortcuts: [
  //     {
  //         symbol: "↵",
  //         label: "Select the date in focus",
  //         symbolDescription: "Enter key"
  //     },
  //     {
  //         symbol: "←/→",
  //         label: "Move backward (left) and forward (down) by one day.",
  //         symbolDescription: "Left or right arrow keys"
  //     },
  //     {
  //         symbol: "↑/↓",
  //         label: "Move backward (up) and forward (down) by one week.",
  //         symbolDescription: "Up or down arrow keys"
  //     },
  //     {
  //         symbol: "PgUp/PgDn",
  //         label: "Switch months.",
  //         symbolDescription: "PageUp and PageDown keys"
  //     },
  //     {
  //         symbol: "Home/End",
  //         label: "Go to the first or last day of a week.",
  //         symbolDescription: "Home or End keys"
  //     },
  //     {
  //         symbol: "Esc",
  //         label: "Close this panel",
  //         symbolDescription: "Escape key"
  //     },
  //     {
  //         symbol: "?",
  //         label: "Open this panel",
  //         symbolDescription: "Question mark"
  //     }
  // ]
};

Vue.component("fa-icon", FontAwesomeIcon);
Vue.component("multiselect", Multiselect);
Vue.component("datetime", Datetime);

Vue.use(BootstrapVue);
Vue.use(Datetime);
Vue.use(AirbnbStyleDatepicker, datepickerOptions);
Vue.use(DatePicker);
Vue.use(Notifications);
Vue.use(VueFlatPickr);
Vue.use(SweetModal);
Vue.use(Autocomplete);
Vue.component("v-select", vSelect);

router.beforeEach(async (to, from, next) => {
  store.state.isLoading = false;

  if (store.state.isEditing) {
    let confirmRoute = await Swal.fire({
      title: "คุณกำลังออกจากหน้าที่กำลังแก้ไขข้อมูลและยังไม่ได้ถูกบันทึก",
      text:
        "หากคุณออกจากหน้านี้ ข้อมูลที่คุณแก้ไขจะไม่ถูกเปลี่ยนแปลง คุณต้องการออกจากหน้านี้ใช่หรือไม่",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "ออกจากหน้านี้",
      cancelButtonText: "อยู่ต่อ",
    });

    if (!confirmRoute.value) {
      next(false);
      return;
    } else {
      // eslint-disable-next-line require-atomic-updates
      store.state.isEditing = false;
    }
  }

  // eslint-disable-next-line require-atomic-updates
  store.state.routeName = to.path.split("/")[1];

  if (to.matched.some((record) => record.meta.requiresAuth)) {
    // this route requires auth, check if logged in
    // if not, redirect to login page.
    if (store.state.Auth.accessToken == null) {
      next({
        name: "login",
      });
    }
  } else if (to.matched.some((record) => record.meta.requiresVisitor)) {
    // this route requires auth, check if logged in
    // if not, redirect to login page.
    if (store.state.Auth.accessToken !== null) {
      next({
        name: "history",
      });
    }
  }

  if (to.matched.some((record) => record.meta.accountantAuth)) {
    store
      .dispatch("Order/checkPermission", {
        type: "accountant",
        mod: "can_view",
      })
      .then((pm) => {
        if (!pm) {
          next({
            name: "history",
          });
        }
      });
  }

  if (to.matched.some((record) => record.meta.resultAuth)) {
    store
      .dispatch("Order/checkPermission", { type: "result", mod: "can_view" })
      .then((pm) => {
        if (!pm) {
          next({
            name: "history",
          });
        }
      });
  }

  if (to.matched.some((record) => record.meta.receiveAuth)) {
    store
      .dispatch("Order/checkPermission", {
        type: "receive_order",
        mod: "can_view",
      })
      .then((pm) => {
        if (!pm) {
          next({
            name: "history",
          });
        }
      });
  }

  if (to.matched.some((record) => record.meta.addAccountantAuth)) {
    store
      .dispatch("Order/checkPermission", {
        type: "accountant",
        mod: "can_create",
      })
      .then((pm) => {
        if (!pm) {
          next({
            name: "history",
          });
        }
      });
  }

  if (to.matched.some((record) => record.meta.editAccountantAuth)) {
    store
      .dispatch("Order/checkPermission", {
        type: "accountant",
        mod: "can_edit",
      })
      .then((pm) => {
        if (!pm) {
          next({
            name: "history",
          });
        }
      });
  }

  if (to.matched.some((record) => record.meta.settingsAuth)) {
    store
      .dispatch("Order/checkPermission", {
        type: "settings",
        mod: "can_access",
      })
      .then((pm) => {
        if (!pm) {
          next({
            name: "history",
          });
        }
      });
  }

  next();
});

new Vue({
  router,
  store,
  _,
  render: (h) => h(App),
}).$mount("#app");
